import { createAction, props } from '@ngrx/store';

// Get Lookup Definitions
export const getLookupDefinitions = createAction(
    '[LookupDefinitions] Get',
    props<{ apiConstants: any, tableId: string }>()
);
export const getLookupDefinitionsSuccess = createAction(
    '[LookupDefinitions] Get Success',
    props<{ payload: any }>()
);
export const getLookupDefinitionsFailure = createAction(
    '[LookupDefinitions] Get Failure',
    props<{ error: any }>()
);

// Get Lookup Definitions ById
export const getLookupDefinitionById = createAction(
    '[LookupDefinitions] Get ById',
    props<{ apiConstants: any, lookupdefinitionId: string, appId: string }>()
);
export const getLookupDefinitionByIdSuccess = createAction(
    '[LookupDefinitions] Get ById Success',
    props<{ payload: any }>()
);
export const getLookupDefinitionByIdFailure = createAction(
    '[LookupDefinitions] Get ById Failure',
    props<{ error: any }>()
);

// Save Lookup Definitions
export const saveLookupDefinitions = createAction(
    '[LookupDefinitions] Save',
    props<{ apiConstants: any, payload: any }>()
);
export const saveLookupDefinitionsSuccess = createAction(
    '[LookupDefinitions] Save Success',
    props<{ payload: any }>()
);
export const saveLookupDefinitionsFailure = createAction(
    '[LookupDefinitions] Save Failure',
    props<{ error: any }>()
);

// Update Lookup Definitions
export const updateLookupDefinitions = createAction(
    '[LookupDefinitions] Update',
    props<{ apiConstants: any, payload: any }>()
);
export const updateLookupDefinitionsSuccess = createAction(
    '[LookupDefinitions] Update Success',
    props<{ payload: any }>()
);
export const updateLookupDefinitionsFailure = createAction(
    '[LookupDefinitions] Update Failure',
    props<{ error: any }>()
);

// Delete Lookup Definitions
export const deleteLookupDefinitions = createAction(
    '[LookupDefinitions] Delete',
    props<{ apiConstants: any, lookupdefinitionId: string }>()
);
export const deleteLookupDefinitionsSuccess = createAction(
    '[LookupDefinitions] Delete Success',
    props<{ payload: any }>()
);
export const deleteLookupDefinitionsFailure = createAction(
    '[LookupDefinitions] Delete Failure',
    props<{ error: any }>()
);